// * MUI Components
import { Box, Container, Typography, styled } from "@mui/material";
import { Twitter, LinkedIn, GitHub } from "@mui/icons-material";
import logoImg from "../assets/images/logos/fulllogo_transparent_nobuffer.png";
import ShapeBackground from "./fancy/ShapeBackground";

// * Styled Components
const CustomContainer = styled(Container)(({ theme }) => ({
  display: "flex",
  justifyContent: "space-around",
  gap: theme.spacing(5),
  [theme.breakpoints.down("md")]: {
    flexDirection: "column",
    gap: theme.spacing(4),
  },
  [theme.breakpoints.down("sm")]: {
    textAlign: "center",
    gap: theme.spacing(3),
  },
}));

const IconBox = styled(Box)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  gap: "1rem",
  [theme.breakpoints.down("sm")]: {
    justifyContent: "center",
  },
}));

const FooterLink = styled("span")(({ theme }) => ({
  fontSize: "16px",
  color: "#4A5568",
  fontWeight: "400",
  cursor: "pointer",
  "&:hover": {
    color: "#3370FF",
  },
  [theme.breakpoints.down("sm")]: {
    fontSize: "14px",
  },
}));

const FooterSection = styled(Box)(({ theme }) => ({
  [theme.breakpoints.down("sm")]: {
    marginBottom: theme.spacing(2),
  },
}));

export default function Footer() {
  return (
    <Box sx={{ py: 10, position: "relative", overflow: "hidden" }}>
      <ShapeBackground />
      <CustomContainer sx={{ position: "relative", zIndex: 1 }}>
        <Box sx={{
          maxWidth: { xs: "100%", sm: "300px" },
          mx: { xs: "auto", sm: 0 }
        }}>
          <img
            src={logoImg}
            alt="Dizpurse Logo"
            style={{
              maxWidth: "150px",
              marginBottom: "1rem",
              width: "100%",
              height: "auto"
            }}
          />
          <Typography
            sx={{
              fontSize: "16px",
              color: "#2B3674",
              fontWeight: "400",
              mb: 3,
              lineHeight: 1.8,
            }}
          >
            Automate your money with rules that save more, pay down debt faster, and keep your finances healthy.
          </Typography>
          <IconBox>
            <Box sx={{
              width: 40,
              height: 40,
              borderRadius: "50%",
              backgroundColor: "#3370FF",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              cursor: "pointer",
              "&:hover": {
                backgroundColor: "#2756CC",
              }
            }}>
              <Twitter sx={{ color: "white", fontSize: 20 }} />
            </Box>
            <Box sx={{
              width: 40,
              height: 40,
              borderRadius: "50%",
              backgroundColor: "#3370FF",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              cursor: "pointer",
              "&:hover": {
                backgroundColor: "#2756CC",
              }
            }}>
              <LinkedIn sx={{ color: "white", fontSize: 20 }} />
            </Box>
            <Box sx={{
              width: 40,
              height: 40,
              borderRadius: "50%",
              backgroundColor: "#3370FF",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              cursor: "pointer",
              "&:hover": {
                backgroundColor: "#2756CC",
              }
            }}>
              <GitHub sx={{ color: "white", fontSize: 20 }} />
            </Box>
          </IconBox>
        </Box>

        <FooterSection>
          <Typography
            sx={{
              fontSize: { xs: "18px", sm: "20px" },
              color: "#2B3674",
              fontWeight: "600",
              mb: 2,
            }}
          >
            Product
          </Typography>

          <FooterLink>Features</FooterLink>
          <br />
          <FooterLink>How It Works</FooterLink>
          <br />
          <FooterLink>Security</FooterLink>
          <br />
          <FooterLink>Pricing</FooterLink>
        </FooterSection>

        <FooterSection>
          <Typography
            sx={{
              fontSize: { xs: "18px", sm: "20px" },
              color: "#2B3674",
              fontWeight: "600",
              mb: 2,
            }}
          >
            Company
          </Typography>

          <FooterLink>About</FooterLink>
          <br />
          <FooterLink>Blog</FooterLink>
          <br />
          <FooterLink>Careers</FooterLink>
          <br />
          <FooterLink>Contact</FooterLink>
        </FooterSection>

        <FooterSection>
          <Typography
            sx={{
              fontSize: { xs: "18px", sm: "20px" },
              color: "#2B3674",
              fontWeight: "600",
              mb: 2,
            }}
          >
            Legal
          </Typography>

          <FooterLink>Privacy Policy</FooterLink>
          <br />
          <FooterLink>Terms of Service</FooterLink>
          <br />
          <FooterLink>Cookie Policy</FooterLink>
          <br />
          <FooterLink>Licenses</FooterLink>
        </FooterSection>
      </CustomContainer>

      <Container sx={{
        mt: 6,
        pt: 4,
        borderTop: "1px solid rgba(43, 54, 116, 0.2)",
        position: "relative",
        zIndex: 1
      }}>
        <Typography
          sx={{
            fontSize: { xs: "12px", sm: "14px" },
            color: "#2B3674",
            textAlign: "center",
            px: 2,
          }}
        >
          © {new Date().getFullYear()} Dizpurse. All rights reserved. | Built with financial discipline in mind.
        </Typography>
      </Container>
    </Box>
  );
}
